import React from "react";
import TableHeader from "../../Common/TableHeader";
import Loader from "../../Common/Loader";
import { Link } from "react-router-dom";

function ReplacementsPerSchool({replacementsPerSchool, loading, loading2, startDate, setStartDate, endDate, setEndDate, searchReplacements, resetSearch}) {

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchReplacements(e);
  };

  const handleReset = (e) => {
    e.preventDefault();
    resetSearch(e);
  };
    return (
        <div className="col-lg-12">
                      <div className="card custom-card" style={{paddingBottom:"10px"}}>
                        <div className="card-body map-card">
                        <TableHeader
                            title="Replacements / Swaps Per School"
                            subtitle="Total number of card and wristband replacements for each registered school"
                            viewButton={
                              <Link onClick={handleReset} className="" style={{float:"right"}}><i class="fas fa-redo-alt ml-3"></i></Link>
                                 
                          } 
                        />
                        <form className="mg-t-20" onSubmit={handleSearchSubmit}>
      <div className="row gutters-5">
        <div className="col-11-xxxl col-lg-11 col-12 form-group">
          <div className="row">
            
            
            <div className="col-lg-12 mt-1">
              <div className="flex-fill position-relative">
              <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="start date"
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="form-control"
                    placeholder="end date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-1-xxxl col-lg-1 col-12 form-group">
        <div className="row">
        <div className="col-lg-12 mt-1">
         <Link onClick={handleSearchSubmit} className="btn btn-primary"><i className="fa fa-search" style={{fontSize:"15px", padding:"8px", color:"white"}}></i></Link></div>
          </div>
        </div>
      </div>
    </form>
    {loading || loading2 ? (
  <Loader />
) : (
  <table className="table mb-0 mw-100 color-span">
    <thead>
                <tr>
                <th className="w-50">School</th>
                <th></th>

                <th className="py-2 px-0" scope="col">Card</th>
                <th className="py-2 px-0"scope="col"> Wristband</th>
                </tr>
                </thead>
    <tbody>
      {Object.keys(replacementsPerSchool).length > 0 ? (
        Object.keys(replacementsPerSchool).map((schoolId, index) => {
          const school = replacementsPerSchool[schoolId];
          return (
            <tr key={index}>
              <td className="py-2 px-0">
                <span className="w-50">{school.school_name}</span>
              </td>
              <td>:</td>
              <td className="py-2 px-0">
                <span className="">
                  {school.replacements[11] !== undefined ? school.replacements[11] : 0}
                </span>
              </td>
              <td className="py-2 px-0">
                <span className="">
                  {school.replacements[13] !== undefined ? school.replacements[13] : 0}
                </span>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan="4" style={{ textAlign: "center" }}>
            No swaps or replacements within this date range.
          </td>
        </tr>
      )}
    </tbody>
  </table>
)}

                        </div>
                      </div>
                    </div>
        
    );
}

export default ReplacementsPerSchool;
